export const reactPortfolio = [
    {
        id: 1,
        title: 'Restaurant Website',
        img: '../assets/pizza.png',
        link: 'https://sleepy-feynman-c70619.netlify.app'
    },
    {
        id: 2,
        title: 'Sport Theme Website',
        img: '../assets/sport.png',
        link: 'https://fervent-galileo-30727f.netlify.app'
    },
    {
        id: 3,
        title: 'Travel Website',
        img: '../assets/travel.png',
        link: 'https://brave-poincare-03a258.netlify.app'
    },
]
export const flutterPortfolio = [
    {
        id: 1,
        title: 'Restaurant Website',
        img: '../assets/ling.png',
        link: 'https://www.youtube.com/watch?v=OdggBIE5Ecc'
    },

]

export const pythonPortfolio = [
    

]